import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../lib/apiClient";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) navigate("/admin", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin", { replace: true });
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full border border-gray-300 bg-white px-4 py-2.5 rounded-md focus:border-[#00331D] focus:ring-1 focus:ring-[#00331D] focus:outline-none";

  return (
    <div className="min-h-screen bg-[#F8F8F8] flex items-center justify-center px-5">
      <form onSubmit={submit} data-testid="admin-login-form" className="w-full max-w-md bg-white border border-gray-200 rounded-lg shadow-sm p-8">
        <div className="flex items-center gap-3 mb-7">
          <div className="w-11 h-11 bg-[#00331D] rounded-md flex items-center justify-center">
            <Lock className="w-5 h-5 text-white" />
          </div>
          <div>
            <div className="font-bold text-lg text-[#1a1a1a]">Land ClearCo</div>
            <p className="text-xs text-[#585858] uppercase tracking-wider">Hiring Dashboard</p>
          </div>
        </div>

        {error && (
          <div data-testid="login-error" className="mb-5 border border-red-200 bg-red-50 text-red-700 px-4 py-3 rounded-md text-sm">
            {error}
          </div>
        )}

        <label className="block text-sm font-semibold text-[#1a1a1a] mb-1.5">Email</label>
        <input type="email" className={inputCls} data-testid="login-email" value={email} onChange={(e) => setEmail(e.target.value)} />

        <label className="block text-sm font-semibold text-[#1a1a1a] mb-1.5 mt-4">Password</label>
        <input type="password" className={inputCls} data-testid="login-password" value={password} onChange={(e) => setPassword(e.target.value)} />

        <button type="submit" disabled={loading} data-testid="login-submit-btn" className="mt-7 w-full bg-[#00331D] text-white font-semibold uppercase tracking-wider px-8 py-3 rounded-md hover:bg-[#004d2b] transition-colors disabled:opacity-60 flex items-center justify-center gap-2">
          {loading && <Loader2 className="w-5 h-5 animate-spin" />}
          {loading ? "Signing in…" : "Sign In"}
        </button>
      </form>
    </div>
  );
}
